<!--
 * @Description: 科室列表页面
 * @Author: gaohc
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-row class="bk-search" style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="6" style="text-align: left">
        <span class="search-title">所属医院：</span>
        <el-select size="small" style="width: 180px" placeholder="请输入/选择" clearable
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
						'hospitalList', srcHospitalList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
						visible, 'hospitalList', srcHospitalList, this)"
          v-model="filterParams.hospitalId" filterable @change="handelChangeHospital">
          <el-option v-for="item in hospitalList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align: left">
        <span class="search-title">科室名称：</span>
        <el-input size="small" style="width: 180px" clearable
				 	placeholder="请输入科室名称" v-model="filterParams.deptName">
        </el-input>
      </el-col>
      <el-col :span="6" style="text-align: left">
        <span class="search-title">科室类别：</span>
        <el-select size="small" style="width: 180px" placeholder="请输入/选择"
          clearable v-model="filterParams.category" filterable>
          <el-option v-for="(item, key) in categoryMap"
            :key="key" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" style="width: 80px;">
          搜 索
        </el-button>
        <el-button v-if="dataPvgList.includes('DEPT_1_CREATE')" size="small" @click="handleAddDep" type="primary" icon="el-icon-plus" style="width: 80px;">
          新 增
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>

    <el-table style="margin: 25px 40px; border: 1px solid #f0f0f0" :style="tableWidth"
      ref="table" :data="dataTable" header-cell-class-name="table-header-color" row-key="id"
      :tree-props="{ children: 'departmentList', hasChildren: 'hasChildren' }"
      :default-sort="{ prop: 'date', order: 'descending' }">
      <el-table-column label="科室名称" min-width="15%" prop="name" align="left">
      </el-table-column>
      <el-table-column prop="hospitalName" label="所属医院" min-width="15%" align="left">
      </el-table-column>
      <el-table-column label="服务机构" min-width="17%" align="left">
        <template slot-scope="scope">
          <span>
						{{ scope.row.institutionName ? scope.row.institutionName : "- -" }}
					</span>
        </template>
      </el-table-column>
      <el-table-column prop="categoryText" label="科室类别" min-width="8%" align="left">
      </el-table-column>
      <el-table-column label="创建时间" min-width="13%" sortable align="left">
        <template slot-scope="scope">
          {{ rebuildDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="序号" type="" min-width="7%" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.level == 1">
            {{ scope.row.ontLevelSort }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" min-width="8%" align="left">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1"
            :disabled="!dataPvgList.includes('DEPT_3_STATUS_CHG')"
            :inactive-value="0" @change="handleStatusSwitch(scope.row)">
					</el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="18%" align="left">
        <template slot-scope="scope">
          <template v-if="dataPvgList.includes('DEPT_2_UPDATE')">
            <el-button type="text" size="small" @click="handleOperation(scope.row, '编辑')">
              编辑
            </el-button>
            <el-divider direction="vertical"></el-divider>
          </template>
          <template v-if="dataPvgList.includes('DEPT_4_DELETE')">
            <el-button type="text" size="small" @click="handleOperation(scope.row, '删除')">
              删除
            </el-button>
            <el-divider direction="vertical"></el-divider>
          </template>
          <template v-if="scope.row.level == 1 && dataPvgList.includes('DEPT_5_SUB_CREATE')">
            <el-button type="text" size="small" @click="handleOperation(scope.row, '新增子科室')">
              新增子科室
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
    </el-row>

    <!-- 一级科室dialog -->
    <department-dialog :visible="showDepDialog" ref="depTree" 
      :hspName="hspName" :hspId="hspId" :mode="dialogMode"
      @add-secondDep="handleAddSecondDep" @edit-secondDep="handleEditSecondDep"
      :oneLevelDep="oneLevelDep" @edit-ward="handleEditInpatient(arguments)"
      @close-dialog="closeDepDialog">
    </department-dialog>

    <!-- 二级科室dialog -->
    <second-department-dialog :visible="showSecondDepDialog" ref="secondDepChild"
      :mode="mode" :topDepName="topDepName" @close-dialog="closeSecondDepDialog"
      :hospitalId="hospitalId" :level2DepId="level2DepId" @add-ward="handleAddWard(arguments)"
      :topDepId="topDepId" @edit-add-ward="handleEditAddInpatient(arguments)"
      @edit-ward="handleEditInpatient(arguments)">
    </second-department-dialog>

    <!-- 病房dialog -->
    <inpatient-ward-dialog :visible="showWardDialog" :mode="modeType" :inpatientId="inpatientId"
      @add-inpatient="handleAddInpatitent" :addSource="addSource" :secondDepId="secondDepId"
      @close-dialog="closeWardDialog">
		</inpatient-ward-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import Util from "@/global/Util.js";
import DepartmentTree from "./components/departmentList/DepartmentTree.vue";
import SecondDepartmentDialog from "./components/departmentList/SecondDepartmentDialog.vue";
import InpatientWardForm from "./components/departmentList/InpatientWardForm.vue";

export default {
  name: "DepartmentList",
  components: {
    "department-dialog": DepartmentTree,
    "second-department-dialog": SecondDepartmentDialog,
    "inpatient-ward-dialog": InpatientWardForm,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      categoryMap: {}, //科室类别Object
      hospitalList: [], //所属医院list
      srcHospitalList: [],
      filterParams: {
        hospitalId: -1,
        deptName: null,
        category: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      dataTable: [],

      //一级科室详情dialog变量
      hspName: "",
      hspId: "",
      oneLevelDep: "",
      showDepDialog: false,
      dialogMode: "",

      //二级科室详情diaog变量
      topDepId: "",
      hospitalId: "",
      topDepName: "",
      level2DepId: "",
      showSecondDepDialog: false,
      mode: "",

      //病房dialog变量
      showWardDialog: false,
      secondDepId: "",
      modeType: "",
      inpatientId: "",

      addSource: "", //打开病房页面的上一页标识
      sourcePage: "", //科室树或者列表打开二级标识
    };
  },
  computed: {
    tableWidth() {
      return  "width:" + (this.$root.contentWidth - 80) + "px";
    },
  },
  methods: {
    //获取查询过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_DEPARTMENT_LIST_FILTERDO).then((result) => {
            if (result == null) {
              return;
            }

            this.categoryMap = this.commonUtil.map2List(result.data.categoryMap,
              false, "value", "label");
            this.hospitalList = result.data.hospitalList;
            this.srcHospitalList = result.data.hospitalList;
            resolve();
          })
      });
    },

		// 获取科室列表数据
    listDepartments() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_DEPARTMENT_LIST,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          this.dataTable = result.data;
          this.totalNumber = result.totalNumber;
          resolve();
        })
      });
    },

    //所有操作逻辑
    handleOperation(item, opeType) {
      if (opeType == "删除") {
        this.handleDeleteDep(item);
      } else if (item.level == 1 && opeType == "编辑") {
        this.handleEdit(item.hospitalId, item);
      } else if (item.level == 1 && opeType == "新增子科室") {
        this.handleAddSecondDep(item.id, item.hospitalId, item.name, "depList");
      } else if (item.level == 2 && opeType == "编辑") {
        this.handleEditSecondDep(item);
      }
    },

    handleQuery() {
      this.filterParams.page = 1;
      this.listDepartments();
    },

    handleAddDep() {
      this.dialogMode = "add";
      this.hspId = this.filterParams.hospitalId;
      this.showDepDialog = true;
    },

    //启用状态改变
    handleStatusSwitch(item) {
      let status = item.status == 1 ? "enable" : "disable";
      let strMessage = item.status == 1 ? "确认是否启用？" : "确认是否停用？";
      this.$confirm(strMessage, "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        let params = {
          id: item.id,
          status: status
        };
        let url = Constant.URL_UPDATE_DEPARTMENT_STATUS;
        this.queryStatusChange('PUT', params, url);
      }).catch(() => {
        this.listDepartments();
      });
    },

    //科室启用状态改变或者删除科室通用逻辑
    queryStatusChange(methods, params, url) {
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: methods,
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        this.listDepartments();
      });
    },

    //一级科室编辑
    handleEdit(_hspId, depItem) {
      this.dialogMode = "edit";
      this.oneLevelDep = depItem;
      this.showDepDialog = true;
    },

    rebuildDate(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },

    handelChangeHospital(val){
      this.hspName = Util.searchKeyWithValueInArr("id", val, this.hospitalList).name;
    },

    //二级科室新增
    handleAddSecondDep(depId, hspId, depName, sourcePage) {
      this.mode = "add";
      this.topDepId = depId;
      this.hospitalId = hspId;
      this.topDepName = depName;
      this.sourcePage = sourcePage;
      this.showSecondDepDialog = true;
    },

    handleEditSecondDep(item) {
      this.mode = "edit";
      this.level2DepId = item.id;
      this.topDepId = item.department1Id;
      this.showSecondDepDialog = true;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listDepartments();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listDepartments();
    },

    //关闭科室dialog
    closeDepDialog(refresh) {
      this.showDepDialog = false;
      if(refresh) this.listDepartments();
    },

    //关闭二级科室dialog
    closeSecondDepDialog(refresh) {
      this.showSecondDepDialog = false;
      if (refresh) this.listDepartments();

      if (refresh && this.sourcePage == "depTree")
        this.$refs.depTree.queryDepTree(this.hospitalId);
    },

    handleAddWard(args) {
      this.modeType = "add";
      this.addSource = args[0];
      this.showWardDialog = true;
    },

    handleEditInpatient(args) {
      this.modeType = "edit";
      this.inpatientId = args[0];
      this.addSource = args[1];
      this.showWardDialog = true;
    },

    handleEditAddInpatient(args) {
      this.modeType = "editNotHaveId";
      this.addSource = args[1];
      this.showWardDialog = true;
    },

    //病房点击保存事件
    handleAddInpatitent(param) {
      this.$refs.secondDepChild.handleInpatitentData(param);
    },

    closeWardDialog(refresh) {
      this.showWardDialog = false;
      if (refresh) this.$refs.depTree.queryDepTree();
    },

    //删除一级，二级科室弹窗
    handleDeleteDep(item) {
      if (!item.canDelete) {
        this.$message.warning("科室下病房有关联订单,暂时不能删除");
        return;
      }

      let content;
      if (item.level == 1) {
        content = '<span style="color:#3D7EF4">' + item.name +
          '</span> 及分组内所有 <span style="color:#3D7EF4">二级科室</span>  将被删除，是否继续删除？';
      } else {
        content = "二级科室 " + item.name + " 将被删除，是否继续删除？";
      }

      this.$confirm(content, "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      }).then(() => {
        let params = {id: item.id};
        let url = Constant.URL_DELETE_DEPARTMENT;
          this.queryStatusChange("DELETE", params, url);
			});
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'DEPT'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    //初始化数据
    async initView() {
      await this.getDataPvg4CurRole();
      this.filterParams.hospitalId = this.$route.params.hospitalId;
      await this.getFilterDo();
      if (this.filterParams.hospitalId) this.handelChangeHospital(this.filterParams.hospitalId);
      await this.listDepartments();
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "医院管理", text2: "科室列表" });
    this.initView();
  },
};
</script>

<style>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}

.child-tabel::before {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/DepartmentList.vue